module.exports = __webpack_public_path__ + "static/img/background.446231a1.svg";